import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-placeholder-loader',
  templateUrl: './placeholder-loader.component.html',
  styleUrls: ['./placeholder-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceholderLoaderComponent {
  constructor() {}
}
